import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TYPES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { getField, updateField } from 'vuex-map-fields'

const workflowTypes = {
  namespaced: true,
  state: buildInitialState({
    workflowTypeList: []
  }),
  getters: { getField },
  actions: {
    getWorkflowTypes ({ commit, state }) {
      if (state.workflowTypeList.length > 0) {
        return Promise.resolve(state.workflowTypeList)
      }

      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_WORKFLOW_TYPES })
        .then(json => json.data)
        .then(types => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTypes', types)
          return types
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowTypes (state, types) {
      state.workflowTypeList = types
    }
  }
}

export default workflowTypes
